var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAgent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 15V13.6667C11.3334 12.9594 11.0525 12.2811 10.5524 11.781C10.0523 11.281 9.37399 11 8.66675 11H3.33341C2.62617 11 1.94789 11.281 1.4478 11.781C0.9477 12.2811 0.666748 12.9594 0.666748 13.6667V15",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00041 8.33333C7.47317 8.33333 8.66707 7.13943 8.66707 5.66667C8.66707 4.19391 7.47317 3 6.00041 3C4.52765 3 3.33374 4.19391 3.33374 5.66667C3.33374 7.13943 4.52765 8.33333 6.00041 8.33333Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 7C10.5004 6.65753 10.5004 5.5 10.5004 5.5M1.50024 7C1.50024 6.65753 1.50024 6 1.50039 5.5M10.5004 4C9.72881 2.2341 8.05068 1 6.00036 1C3.95004 1 2.27165 2.2341 1.5001 4",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/agent.47a33679.svg";
export { ForwardRef as ReactComponent };